// Table weekday toggles (stable ids, never translated).
export const ALL_WEEKDAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']

// Weekdays of a report execution (`weekdays` from saved-filters) or every day when the report has no weekday filter.
export const weekdaysOrAll = (weekdays) => weekdays?.length ? weekdays : ALL_WEEKDAYS
